import React, { useEffect, useState } from 'react';
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <nav className="sticky top-0 z-50 transition-all duration-300" style={{
    backgroundColor: scrolled ? 'rgba(251, 248, 244, 0.85)' : 'transparent',
    backdropFilter: scrolled ? 'blur(12px)' : 'none',
    borderBottom: scrolled ? '1px solid var(--border-faint)' : '1px solid transparent'
  }} data-id="element-178">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-10" data-id="element-179">
        <div className="flex justify-between h-16 md:h-18 items-center" data-id="element-180">
          <a href="#hero" className="flex items-center gap-2 group" aria-label="Emigo home" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/kPyEtui4sL9gCL5rPK2NdZ/Emigo_Icon_(1)-modified.png" alt="" className="w-8 h-8 rounded-full transition-transform duration-300 group-hover:scale-105" aria-hidden="true" data-id="element-182" />
            <span className="text-xl font-normal" style={{
            color: 'var(--navy)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-183">
              Emigo
            </span>
          </a>

          <a href="https://apps.apple.com/us/app/emigo-better-texting/id6748092950" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-11 md:h-12 px-6 md:px-7 rounded-full text-sm font-medium transition-all duration-300 hover:scale-[1.03]" style={{
          backgroundColor: 'var(--navy)',
          color: '#FFFFFF',
          letterSpacing: '0.01em'
        }} data-id="element-184">
            Download Free
          </a>
        </div>
      </div>
    </nav>;
};
export default Navbar;